import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Image from "../../../../../../base/multimedia/image/index.js";
import * as S from "./styled.js";
const Banner = ({ banner , link , viewMore , isLoading , isFlat  })=>{
    if (isLoading) return /*#__PURE__*/ _jsx(S.SkeletonWrapper, {
        variant: "rectangular",
        animation: "wave",
        height: "148px"
    });
    if (!banner) return null;
    const { link: linkBanner , ...restBanner } = banner;
    const bannerProps = {
        resize: {
            operation: 'resize',
            suboperation: 'crop',
            width: 1436,
            height: 150,
            quality: 97
        },
        alternative: '/comun/images/not-available.png',
        ...restBanner
    };
    return /*#__PURE__*/ _jsx(S.BannerWrapper, {
        "data-testid": "Banner",
        $isFlat: isFlat,
        children: /*#__PURE__*/ _jsx(S.BannerContainer, {
            children: /*#__PURE__*/ _jsxs("a", {
                href: linkBanner?.href ?? link,
                title: banner.title ?? '',
                children: [
                    /*#__PURE__*/ _jsx(Image, {
                        ...bannerProps
                    }),
                    /*#__PURE__*/ _jsxs(S.BannerMask, {
                        children: [
                            banner.title && /*#__PURE__*/ _jsx(S.BannerText, {
                                children: banner.title
                            }),
                            viewMore && /*#__PURE__*/ _jsx(S.BannerButton, {
                                children: viewMore
                            })
                        ]
                    })
                ]
            })
        })
    });
};
export default Banner;

//# sourceMappingURL=index.js.map